import { Injectable } from '@angular/core';
import { ActiveErrorResponse, Gateway } from '../../../projects/client';
import { isValidViessmannSerial } from '../_common/serial-helpers';
import { ActiveErrorData } from './active-errors.model';
import { TranslationConfigService } from '../../shared/services/translation-config.service';

@Injectable({ providedIn: 'root' })
export class ActiveErrorsMappers {
  constructor(private translationConfig: TranslationConfigService) {}

  mapResponseIntoStoreModel(
    activeErrorsResponse: ActiveErrorResponse[],
    installationGateways: Gateway[]
  ): ActiveErrorData[] {
    return activeErrorsResponse.map((error) => {
      const errorData: ActiveErrorData = {
        deviceSerial: null,
        appearedAt: error.content.appearedAt,
        createdAt: error.createdAt,
        errorDescription: error.content.errorDescription,
        deviceId: error.content.deviceId,
        gatewaySerial: error.content.gatewaySerial,
        id: error.id,
        errorCode: error.content.errorCode,
        countryCode: this.translationConfig.countryCode(),
        langCode: this.translationConfig.langCode(),
        details: null,
        type: error.type,
        loading: false,
        loaded: false,
        isSelected: false,
        content: error.content,
      };

      const activeErrorGateway = installationGateways.find(
        (gateway) => gateway.serial === error.content.gatewaySerial
      );

      // get details for main device ( or lead in cascades )
      if (error.content.deviceId === '0') {
        errorData.deviceSerial = activeErrorGateway.devices.find(
          (device) => device.id === '0'
        ).boilerSerial;
      } else {
        // get details for any other errors which device id is known ( lag devices )
        if (isValidViessmannSerial(error.content.deviceId)) {
          errorData.deviceSerial = error.content.deviceId;
        }
      }

      return errorData;
    });
  }
}
